<template>
  <div ref="codeContainer" class="monaco-editor">
  </div>
</template>
<script>

import * as monaco from 'monaco-editor';
import {format} from 'sql-formatter';

const customLanguage = {
  "go": [],
  "python": []
}
const defaultOptions = {
  theme: "vs-dark", // 主题
  language: 'pgsql',
  languageGroup: 'sql',
  autoIndent: true,
  automaticLayout: true,
  colorDecorators: true, // 颜色装饰器
  accessibilitySupport: "on", // 辅助功能支持"auto" | "off" | "on"
  lineNumbers: "on", // 行号 取值： "on" | "off" | "relative" | "interval" | function
  wordWrap: "on",
  lineNumbersMinChars: 4, // 行号最小字符   number
  enableSplitViewResizing: false,
  readOnly: false, //是否只读  取值 true | false
  scrollBeyondLastLine: false, // 编辑器是否可以滚动到最后一行之后
  minimap: {// 预览小地图，右侧缩略显示
    enabled: true,
  }
};
export default {
  name: 'MonacoEditor',
  data() {
    return {
      editor: null,
      editorOptions: Object.assign(JSON.parse(JSON.stringify(defaultOptions)), this.options),
      // theme: "vs-dark", // 主题
      // language: 'pgsql',
      // languageGroup: 'sql',
      // dataType: 'string',
      // autoIndent: true,
      // automaticLayout: true,
      // colorDecorators: true, // 颜色装饰器
      // accessibilitySupport: "on", // 辅助功能支持"auto" | "off" | "on"
      // lineNumbers: "on", // 行号 取值： "on" | "off" | "relative" | "interval" | function
      // lineNumbersMinChars: 4, // 行号最小字符   number
      // enableSplitViewResizing: false,
      // readOnly: false, //是否只读  取值 true | false
      // scrollBeyondLastLine: false, // 编辑器是否可以滚动到最后一行之后
      // minimap: {// 预览小地图，右侧缩略显示
      //   enabled: true,
      // }
      // },
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Array, Object],
      default: '',
    },
    options: {
      type: Object,
      default: () => {
      }
    },
  },
  watch: {
    // 双向绑定，那么光标每次都在头部位置(采用onDidBlurEditorWidget)
    // 取消双向绑定，则父组件采用间接设置值
    value(val) {
      if (this.editor) {
        // console.log('----watch value------', val)
        this.setValue(this.serialize(val));// 重新设置导致光标会到头部
        if (this.options.autoFormat) {
          this.format();
        }
      }
    },
    options: {
      handler(val) {
        if (this.editor) {
          this.editorOptions = Object.assign(JSON.parse(JSON.stringify(defaultOptions)), val);
          console.log('----watch options------', this.editorOptions);
          this.editor.updateOptions(this.editorOptions);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.initEditor();
  },
  methods: {
    serialize(json) {
      if (this.editorOptions.dataType === 'object') {
        return (typeof json === 'object') ? JSON.stringify(json) : json;
      }
      return json;
    },
    deserialize(str) {
      if (this.editorOptions.dataType === 'object') {
        return JSON.parse(str);
      }
      return str;
    },

    /**
     * 初始化editor
     */
    initEditor() {
      console.log('----initEditor------', this.editorOptions);
      this.editorOptions.value = this.serialize(this.value);
      this.editor = monaco.editor.create(this.$refs.codeContainer, this.editorOptions);

      setTimeout(() => {
        if (this.editorOptions.autoFormat) {
          console.log("自动格式化处理");
          this.format();
        }
      }, 500);

      // 添加sql
      this.addSqlFormatMenu();

      // this.editor.onDidChangeModelContent(event => {
      this.editor.onDidBlurEditorWidget(event => {
        // 监听value会，watch设置值，导致光标回到head
        this.$emit('change', this.deserialize(this.getValue()));
      });
    },
    /**
     * 格式化SQL
     * @param raw
     * @returns {*}
     */
    format() {
      if (this.editorOptions.language === 'json') {
        this.formatJson();
      } else if (this.editorOptions.languageGroup === 'sql') {
        this.setValue(this.formatSql(this.getValue()));
      }
    },

    // 格式化sql
    formatSql(raw) {
      return format(raw);
    },
    // 格式化json
    formatJson() {
      this.editor.getAction('editor.action.formatDocument').run();
    },
    /**
     * 添加菜单
     */
    addSqlFormatMenu() {
      if (['sql', 'mysql', 'pgsql'].includes(this.editorOptions.language) || this.editorOptions.languageGroup === 'sql') {
        let that = this;
        this.editor.addAction({
          id: 'ctxMenuCodeFormat',
          label: 'Format Document',
          keybindings: [monaco.KeyMod.Shift | monaco.KeyMod.Alt | monaco.KeyCode.KeyF],
          contextMenuGroupId: '1_modification', // 放在默认菜单组
          contextMenuOrder: '4',
          run: function (editor, args) {
            this.format();
          }
        });
      }
    },
    /**
     * 自定义语言
     */
    initCustomLanguage() {
      let language = this.language;
      if (!(Object.keys(customLanguage)).includes(this.language)) {
        return
      }
      monaco.languages.registerCompletionItemProvider(this.language, {
        provideCompletionItems: function () {
          let keywords = customLanguage[language];
          let suggestions = keywords.map(function (keyword) {
            return {
              label: keyword,
              kind: monaco.languages.CompletionItemKind.Keyword,
              insertText: keyword
            };
          });
          return {suggestions: suggestions};
        }
      });
    },
    setValue(val) {
      this.editor.setValue(val);
    },
    getValue() {
      return this.editor.getValue();
    },
    destroyed() {
      if (this.editor) {
        console.log('-----destroyed------')
        this.editor.dispose();
      }
    }
  }
  ,
}
</script>

<style lang="less" scoped>
.monaco-editor {
  height: 100%;
  width: 100%;
}
</style>
